import { render, staticRenderFns } from "./MonitElevator.vue?vue&type=template&id=56ed09ea&scoped=true&"
import script from "./MonitElevator.vue?vue&type=script&lang=js&"
export * from "./MonitElevator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ed09ea",
  null
  
)

export default component.exports